import clsx from 'clsx'
import Image from 'next/image'
import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

import { Ratings } from '../ratings/Ratings'
import { Badge } from '../../atoms'
import { StatusColorEnum } from '../../atoms/fields/Badge/StatusColorEnum'
import OwnerResponsePopover from '../../organisms/owner-response-popover/OwnerResponsePopover'

export interface IEntityDetailsProps {
  pictureUri: string
  title: string
  rating?: number
  userRatingsTotal?: number
  style?: CSSProperties
  className?: string
  disableHover?: boolean
  nabooRating?: {
    rating?: number | null | undefined
    ratingsTotal?: number | null | undefined
  }
  ownerAnswerInfos?: {
    answerRate?: number | null | undefined
    avgAnswerTime?: number | null | undefined
  }
  isRecommended?: boolean
}

const EntityDetails = ({
  pictureUri,
  title,
  bgColor,
  rating,
  userRatingsTotal,
  style,
  className,
  disableHover,
  ownerAnswerInfos,
  isRecommended,
  nabooRating,
}: IEntityDetailsProps & { bgColor?: StatusColorEnum }) => {
  return (
    <div className={clsx(s.container, className)} style={style}>
      <Image
        className={s.image}
        src={pictureUri}
        width={45}
        height={45}
        alt="Image de l'entité principale"
        style={{
          borderRadius: '4px',
          objectFit: 'cover',
          width: '45px',
          height: '45px',
        }}
      />
      <div className={s.labelsContainer}>
        <div className={s.textWithBadgeContainer}>
          <p className={s.title}>{title}</p>
          {bgColor && <Badge bgColor={bgColor} classname={s.badge} />}
        </div>
        <div className={s.ratings}>
          <Ratings
            nabooRating={nabooRating}
            googleRating={{
              rating: rating,
              userRatingsTotal: userRatingsTotal,
            }}
            small
          />
        </div>
        {ownerAnswerInfos &&
          (ownerAnswerInfos.answerRate !== 0 ||
            ownerAnswerInfos.avgAnswerTime !== 0) && (
            <OwnerResponsePopover
              answerRate={ownerAnswerInfos.answerRate}
              avgAnswerTime={ownerAnswerInfos.avgAnswerTime}
              disableHover={disableHover}
            />
          )}
      </div>
      {isRecommended && <div className={s.recommended}>Recommandé</div>}
    </div>
  )
}

export default EntityDetails
